import {
  Control,
  FieldValues
} from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useGetCivilites } from "../../../hooks/react-query/dropdowns/civilites.queries";
import { useGetDirections } from "../../../hooks/react-query/dropdowns/directions.queries";
import Loader from "../../global/Loader/Loader";
import DropdownSection from "../../inputs/DropdownSection/DropdownSection";
import InputSection from "../../inputs/InputSection/InputSection";
import PhoneSection from "../../inputs/PhoneSection/PhoneSection";

import { CollaborateurFormSchemaType } from "../../../schemas/collaborateur/collaborateurForm.schema";
import styles from "./InscriptionInfoPersonnelles.module.scss";

type Props<FormSchemaType extends FieldValues> = {
  control: Control<FormSchemaType>;

};

export default function InscriptionInfoPersonnelles<FormSchemaType extends FieldValues>(props: Props<FormSchemaType>) {
  const { t } = useTranslation();
  const { control } = props;
  const { data: civilitesData, isLoading: isLoadingCivilite } =
    useGetCivilites();
  const { data: directionsData, isLoading: isLoadingDirection } =
    useGetDirections();

  if (isLoadingCivilite || isLoadingDirection) return <Loader />;
  return (
    <article className={styles.inscriptionInfoPersonnelles}>
      <header className={styles.inscriptionInfoPersonnelles__header}>
        <h2>{t("inscriptionInfoPersonnelles.title")}</h2>
      </header>
      <main className={styles.inscriptionInfoPersonnelles__main}>
        <article
          className={
            styles.inscriptionInfoPersonnelles__main__civiliteContainer
          }
        >
          <section>
            <DropdownSection<CollaborateurFormSchemaType>
              control={control}
              options={civilitesData?.data?.list}
              name={"civilite"}
              placeholder={t("form.selectCivilite")}
              label={t("collaborateur.civilite")}
              inputId="collaborateur_inscription_civilite"
              hasIcon={false}
            />
          </section>
        </article>
        <article
          className={
            styles.inscriptionInfoPersonnelles__main__restOfInfosContainer
          }
        >
          <section>
            <InputSection<CollaborateurFormSchemaType>
              control={control}
              label={t("collaborateur.nom")}
              inputId="collaborateur_inscription_nom"
              inputType="text"
              name={"nom"}
              placeholder={t("collaborateur.nom")}
            />
            <InputSection<CollaborateurFormSchemaType>
              control={control}
              label={t("collaborateur.email")}
              inputId="collaborateur_inscription_email"
              inputType="email"
              name={"email"}
              placeholder={t("collaborateur.email")}
            />
            <InputSection<CollaborateurFormSchemaType>
              control={control}
              label={t("collaborateur.fonction")}
              inputId="collaborateur_inscription_fonction"
              inputType="text"
              name={"fonction"}
              placeholder={t("form.indicateFunction")}
            />
          </section>
          <section className={styles.inscriptionInfoPersonnelles__right}>
            <InputSection<CollaborateurFormSchemaType>
              control={control}
              label={t("collaborateur.prenom")}
              inputId="collaborateur_inscription_prenom"
              inputType="text"
              name={"prenom"}
              placeholder={t("collaborateur.prenom")}
            />

            <PhoneSection<CollaborateurFormSchemaType>
              control={control}
              label={t("collaborateur.phone")}
              inputId="collaborateur_inscription_telephone"
              name="phone"
              placeholder={t("form.phonePlaceholder")}
            />
            <DropdownSection<CollaborateurFormSchemaType>
              control={control}
              options={directionsData?.data?.list}
              name={"direction"}
              label={t("collaborateur.direction")}
              placeholder={t("form.selectService")}
              inputId="collaborateur_inscription_direction"
              hasIcon={false}
            />
          </section>
        </article>
      </main>
    </article>
  );
}
